// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SfRL","newExpiryDate":"styles_newExpiryDate__UO65l","footer":"styles_footer__CrDvm"};